import { render, staticRenderFns } from "./ScrapCarDetail.vue?vue&type=template&id=4681fda4&scoped=true"
import script from "./ScrapCarDetail.vue?vue&type=script&lang=js"
export * from "./ScrapCarDetail.vue?vue&type=script&lang=js"
import style0 from "./ScrapCarDetail.vue?vue&type=style&index=0&id=4681fda4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681fda4",
  null
  
)

export default component.exports